<template>
  <div class="cadastro-usuario">
    <v-container
      fluid
    >
      <h1 class="titulo">Taxa de Conversão</h1>

      <v-row>
        <v-col>
          <v-card>
            <v-card-text class="modal-cadastro-form pa-3 pb-1">
              <v-row class="align-end">
                <v-col cols="12" class="pa-3 pt-0 pb-0">
                  <rangeDate
                    :dtFinalProps.sync="dtFinal"
                    :dtInicialProps.sync="dtInicial"
                  />
                </v-col>
              </v-row>
            </v-card-text>

            <v-card-actions class="modal-cadastro-footer pt-0">

              <v-btn
                type="submit"
                :color="variables.colorPrimary"
                @click.prevent="submit"
                class="br-btn"
                :loading="loading">Processar</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>

      <div class="box-table box-table-gecom">
        <v-skeleton-loader
          :loading="loading"
          :transition="'fade-transition'"
          height="500"
          type="table"
        >
          <v-data-table
            :headers="headersData"
            :items="listaItens"
            :loading="loadingTable"
            :items-per-page.sync="itemsPerPage"
            @click:row="expandRow"
            item-key="created"
            :expanded.sync="expanded"
            show-expand
            single-expand
            hide-default-footer
            dense
          >
            <template v-slot:item.created="{ item }">
                {{ item.created | datas('DD/MM/YYYY') }}
            </template>

            <template v-slot:item.deposits_average="{ item }">
                {{ item.deposits_average | currencyNoSymbol }}
            </template>

            <template v-slot:item.deposits_amount="{ item }">
                {{ item.deposits_amount | currencyNoSymbol }}
            </template>

            <template v-slot:item.conversion_ratio="{ item }">
                {{ Number(item.conversion_ratio).toFixed(2) }} %
            </template>

            <template v-slot:item.deposited_clients_count="{ item }">
                {{ item.deposited_clients_count || 0 }}
            </template>

            <template v-slot:item.deposits_count="{ item }">
                {{ item.deposits_count || 0 }}
            </template>


            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length" class="table-expend" v-if="!loading">
                <template v-for="(v, k) in listaExplains">
                  <v-row class="sub_header" v-if="k === 0" :key="`${k}-header1`">
                    <v-col cols="1" class="text-left"> Id  </v-col>
                    <v-col cols="1" class="text-center"> CPF  </v-col>
                    <v-col cols="2" class="text-center"> Nome </v-col>
                    <v-col cols="2" class="text-center"> Criação </v-col>
                    <v-col cols="1" class="text-center"> Qtd. Depositos </v-col>
                    <v-col cols="1" class="text-center"> Depositos </v-col>
                    <v-col cols="1" class="text-center"> Media Depositos </v-col>
                    <v-col cols="2" class="text-center"> Primeiro - Ultimo Deposito </v-col>
                    <v-col cols="1" class="text-center"> Btag </v-col>
                  </v-row>
                  <template>
                    <v-row :key="k" class="header-line">
                      <v-col cols="1" class="text-left"> {{ v.entity_id }} </v-col>
                      <v-col cols="1" class="text-center"> {{ v.entity_cod }} </v-col>
                      <v-col cols="2" class="text-center text-truncate"> {{ v.entity_fullname }} </v-col>
                      <v-col cols="2" class="text-center"> {{ v.entity_created | datas('DD/MM/YYYY HH:mm')}} </v-col>
                      <v-col cols="1" class="text-center"> {{ v.deposits_count || 0 }} </v-col>
                      <v-col cols="1" class="text-center"> {{ v.deposits_amount || 0 | currencyNoSymbol}} </v-col>
                      <v-col cols="1" class="text-center"> {{ v.deposits_average || 0 | currencyNoSymbol}} </v-col>
                      <v-col cols="2" class="text-center"> {{ v.first_deposit_date | datas('DD/MM/YYYY HH:mm') }}{{v.deposits_count > 1 ? formatLastData(v.last_deposit_date) : ''}} </v-col>
                      <v-col cols="1" class="text-center"> {{ v.entity_btag || '' }} </v-col>
                    </v-row>
                  </template>
                </template>
              </td>
            </template>


            <template v-slot:footer>
              <div class="wrapper-footer">
                <div class="qtd-paginacao">
                  {{ pageStart }}
                  -
                  {{ pageStop }}
                  de
                  {{ totalItens }}
                </div>
                <v-pagination
                  v-model="page"
                  :length="numberOfPages"
                  circle
                  :disabled="loadingTable"
                  :total-visible="10"
                  class="box-table-paginacao"
                  v-if="numberOfPages > 1"></v-pagination>
              </div>
            </template>
              
          </v-data-table>
        </v-skeleton-loader>
      </div>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Events from '@/core/service/events'
// eslint-disable-next-line no-unused-vars
import { parseTime, errorSnackbar } from '@/core/service/utils'
import { mask } from 'vue-the-mask'
import { size } from 'lodash'
import moment from 'moment'
/**
 * MIXIN
 */
import listagemTables from '@/views/mixins/listagemTables'

const namespaceStore = 'taxaConversao'

export default {
  name: 'TaxaConversao',
  components: {
    rangeDate: () => import('../../components/rangeDate'),
  },
  directives: {
    mask
  },
  mixins: [listagemTables],
  data: () => ({
    loading: false,
    loadingTable: false,
    dtFinal: '',
    dtInicial: '',
    inativos: null,

    
    // typeGecom: null,
    entityCod: '',
    dateInit: '',
    dateEnd: '',
    count: 0,
    page: 1,
    expanded: [],
  }),

  mounted () {
    this.dateEnd = this.dtFinal
    this.dateInit = this.dtInicial
  },

  watch: {
    expanded (val) {
      this.loading = true
      if (size(val) > 0) {
        this.getItens({ explainDate: val[0].created })
          .catch(err => {
            errorSnackbar(err.error)
          })
          .finally(() => {
            this.loading = false
          })
      } else {
        this.loading = false
      }
    }
  },

  computed: {
    ...mapGetters(namespaceStore, [ 'listaItens', 'totalItens', 'listaExplains']),
    ...mapGetters('auth', ['user']),

    headersData () {
      return [
        { align: 'start', class: 'table-header', text: 'Data', value: 'created' },
        { align: 'center', class: 'table-header', text: 'Jogadores Registrados', value: 'registered_players' },
        { align: 'center', class: 'table-header', text: 'Jogadores Depositantes', value: 'deposited_clients_count' },
        { align: 'center', class: 'table-header', text: 'Qtd. Depositos', value: 'deposits_count' },
        { align: 'center', class: 'table-header', text: 'Depósitos', value: 'deposits_amount' },
        { align: 'center', class: 'table-header', text: 'Media Depósitos', value: 'deposits_average' },
        { align: 'center', class: 'table-header', text: 'Taxa de Conversão', value: 'conversion_ratio' },
      ]
    },
  },

  methods: {
    ...mapActions(namespaceStore, ['getItens', 'clearItens', 'clearExplains']),

    paginacao (pag) {
      this.page = pag
      this.submit()
    },

    init() {},

    expandRow(value) {
      this.clearExplains()
      this.loading = true
      this.expanded = value 
    },

    formatLastData(data) {
      return moment(data).format(' - DD/MM/YYYY HH:mm')
    },

    submit (resetPage = false) {
      this.loading = true
      this.loadingTable = false

      if (resetPage) this.page = 1

      let { dtInicial, dtFinal } = Object.assign({}, this)

      this.getItens({ dtStart: dtInicial, dtEnd: dtFinal, size: this.$store.getters.ItensPaginacao, page: this.page })
        .catch(err => {
          this.clearItens()
          errorSnackbar(err.error)
        })
        .finally(() => {
          this.count++
          this.loading = false
          this.loadingTable = false
        })

    },
  },

  beforeDestroy () {
    Events.$off('modal::historicoVendas::pgto')
    Events.$off('modal::historicoVendas::caixa')
    Events.$off('modal::historicoVendas::jogosWinners')
    Events.$off('modal::historicoVendas::transmissoes')
  }
}
</script>

<style lang="scss">
  @import '~@/assets/styles/components/table';
  .v-data-table thead tr th,
  .v-data-table .v-data-table-header th.sortable .v-data-table-header__icon {
    color: $colorPrimary !important;
  }

  .box-table {

    .v-data-table-header-mobile {
      display: none;
    }

    &.box-table-gecom {
      .v-data-table > .v-data-table__wrapper > table > tbody > tr > th {
        height: auto;
        padding: 5px;
        font-size: 11px;
      }
    }
  }

  .fab-cadastrar-usuario {
    position: fixed;
    z-index: 1;
    bottom: 25px;
    right: 5px;

    @media (min-width: 599px) {
      display: none !important;
    }
  }

  .theme--light.v-data-table tbody tr.v-data-table__selected{
  background: #14800040;
  &:hover{
    background: #14800040 !important;
  }
}
table tbody tr.v-data-table__expanded__row {
  background: #f1f1f1;
}
table tbody tr.v-data-table__expanded.v-data-table__expanded__content {
  box-shadow: none;
  td.table-expend  {
    padding: 5px 20px;
  }
  box-shadow: none;
  padding-top: 0;
  .row {
    & > div {
      border-bottom: 1px solid #ccc;
      // border-top: 1px solid #ccc;
      // display: flex;
      // justify-content: center;
      // align-items: center;
    }
    background: #d9d9D9;
    &:nth-child(2n +1) {
      background:   #e9e9e9;
    }
    transition: 0.5;
    // border-bottom: 1px solid #ccc;
    &:hover{
      background: #F1F1F1;
    }
  }
  .row.header-line {
    &.isDeleted {
      color: #E53935
    }

    margin-top: 0;
    margin-left: -15px !important;
    margin-right: -15px !important ;
    &:last-child{
      margin-bottom: 0px;
    }
  }
  td > .header {
    margin-top: 0px;
    cursor: hand;
    background:white !important;
    div {
      font-weight: bold;
    }
    &:hover{
      background: white !important;

    }
  }
  td> .row.header-line {
    margin: 0;
  }
}

.sub_header{
    margin-top: 0px;
    background:white !important;
    div {
      font-weight: bold;
      align-items: center;
      margin-top: 0;
    }
}

</style>
